import { createFileRoute } from '@tanstack/react-router';

import { TransactionsPage } from '@/features/transactions/public';

export const Route = createFileRoute('/transactions/')({
  component: TransactionsPage,
});
